<template>
  <div class="vmx-header-container">
    <div
      v-if="terminal"
      id="terminal_container-header"
    >
      <img
        class="terminal_container-header-logo"
        src="https://easddistribute.m-anage.com/from.storage?filecore=hIHaf21vBgLSoB3L9MXCOg"
      />
    </div>
    <header-container
      class="vmx-header"
      :background="background"
      :breakpoint="breakpoint"
      id="vmx-header"
    >
      <banner-menu-layout class="vmx-header__bannerMenu-layout">
        <content-container class="vmx-header__bannerMenu">
          <banner-logos
            class="vmx-header__bannerMenu-left"
            :banners="banners"
            @sideNavigationToggle="toggleNav"
            :header-menu="menu"
          />
          <banner-menu-right-container
            class="vmx-header__bannerMenu-right-container"
          >
            <banner-menu
              class="vmx-header__bannerMenu-right"
              :items="bannerMenuItems"
              :my-congress="menu.myCongress"
            />
            <social-media-icons
              v-if="socialMediaIconsActive"
              class="vmx-header__bannerMenu-right--socialMediaIcons"
            />
          </banner-menu-right-container>
        </content-container>
      </banner-menu-layout>
      <div class="vmx-header__nav-container">
        <navigation
          class="vmx-header__nav"
          :items="menuItems"
          ref="navigation"
          :width="width"
          :side-navigation-open="sideNavigationOpen"
          @sideNavigationToggle="toggleNav"
          :key="componentKey"
        >
          <banner-menu
            :items="bannerMenuItems"
            :mobile-view="true"
            :my-congress="menu.myCongress"
            :width="width"
            :my-congress-items="myCongressItems"
            :breakpoint="breakpoint"
            :custom-menu-items="customMenuItems"
          />
        </navigation>
      </div>
      <template v-if="sideNavigationOpen">
        <background-overlay @click="toggleNav" />
      </template>
    </header-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import headerMixins from '~/mixins/headerMixins'
import Navigation from './Navigation.vue'
import HeaderContainer from './HeaderContainer.vue'
import ContentContainer from './ContentContainer.vue'
import BannerLogos from './BannerLogos.vue'
import BannerMenu from './BannerMenu.vue'
import BannerMenuRightContainer from './BannerMenuRightContainer.vue'
import SocialMediaIcons from './SocialMediaIcons.vue'
import BackgroundOverlay from './BackgroundOverlay.vue'
import BannerMenuLayout from './BannerMenuLayout.vue'

export default {
  name: 'VMXHeader',
  components: {
    HeaderContainer,
    ContentContainer,
    BannerLogos,
    BannerMenu,
    Navigation,
    BackgroundOverlay,
    BannerMenuLayout,
    BannerMenuRightContainer,
    SocialMediaIcons,
  },
  mixins: [headerMixins],
  data() {
    return {
      width: window.innerWidth,
      sideNavigationOpen: false,
      componentKey: 0,
    }
  },
  computed: {
    ...mapGetters({
      headerModel: 'header/model',
      configForKey: 'config/configForKey',
      user: 'user/user',
      event: 'instancesState/getEvent',
      language: 'instancesState/getLanguage',
      instance: 'instancesState/getInstance',
      menuDisabled: 'instancesState/getMenuDisabled',
    }),
    banners() {
      return this.headerConfig.banners
    },
    menu() {
      return this.headerConfig.menu
    },
    socialMediaIconsActive() {
      const items = this.headerConfig.menu?.socialMediaIconsActive
      if (items) {
        return items
      }
      return false
    },
    terminal() {
      return localStorage.getItem('isTerminal')
    },
    menuItems() {
      const items = this.headerConfig.menu?.menuItems
      if (items) {
        return items
      }
      return []
    },
    bannerMenuItems() {
      const items = this.headerConfig.menu?.bannerMenuItems
      if (items) {
        return items
      }
      return []
    },
    background() {
      return this.headerConfig.background
    },
    myCongressItems() {
      const items = this.headerConfig.menu?.myCongressItems
      if (items) {
        return items
      }
      return []
    },
    customMenuItems() {
      const items = this.headerConfig.menu?.customMenuItems
      if (items) {
        return items
      }
      return []
    },
  },
  methods: {
    toggleNav() {
      this.sideNavigationOpen = !this.sideNavigationOpen
    },
    onResize() {
      this.width = window.innerWidth
      if (window.innerWidth > this.breakpoint) {
        this.sideNavigationOpen = false
      }
    },
    forceRerender() {
      this.componentKey += 1
    },
  },
  mounted() {
    this.$root.$on('navRerender', () => {
      this.forceRerender()
    })
    if (window.location.href.indexOf('noheader') !== -1) {
      setTimeout(() => {
        localStorage.removeItem('isApp')
        document.getElementById('vmx-header').style.display = 'none'
        document.getElementById('page-footer').style.display = 'none'
      }, 100)
    }
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style lang="scss">
@media (min-width: 1024px) {
  .vmx-header__nav-container {
    background-color: var(--header-navbar-bg);
    margin: auto;
  }
}
</style>
